import { Link } from 'react-router-dom';
import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';

const Email = () => (
  <>
    <div className="c7-checkout__content__title">
      <h3>Contact information</h3>
      <Link to="/reservation/checkout/login">
        Already have an account? Log in
      </Link>
    </div>

    <Field
      name="email"
      component={TextField}
      autocomplete="email"
      label="Email"
      required
    />
  </>
);

export default Email;
